module.exports = require("core-js/library/fn/array/filter");


//////////////////
// WEBPACK FOOTER
// ../~/@babel/runtime-corejs2/core-js/array/filter.js
// module id = 227
// module chunks = 1